import { __awaiter, __generator } from "tslib";
import { deleteFromSimplePersistence } from '../SimplePersistence';
export function createExpirationPlugin(maxTimeInMs) {
    var _this = this;
    return {
        onBeforeWriteValue: function (value) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!value) {
                    return [2 /*return*/, value];
                }
                return [2 /*return*/, {
                        item: value,
                        persistedAtTimeMs: new Date().getTime(),
                    }];
            });
        }); },
        onAfterReadValue: function (value, key, context) { return __awaiter(_this, void 0, void 0, function () {
            var expirationTime, userId, collectionName, collectionVersion;
            return __generator(this, function (_a) {
                if (!value) {
                    return [2 /*return*/, value];
                }
                expirationTime = maxTimeInMs + value.persistedAtTimeMs;
                // Item is expired.
                if (expirationTime < value.persistedAtTimeMs) {
                    userId = context.userId, collectionName = context.collectionName, collectionVersion = context.collectionVersion;
                    // Delete, but do it asynchronously so it doesn't block returning the result.
                    deleteFromSimplePersistence(userId, collectionName, collectionVersion, key);
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, value.item];
            });
        }); },
    };
}
//# sourceMappingURL=ExpirationPlugin.js.map